import React from 'react';
import { cn } from '@/lib/utils';

export interface FilterItem {
  id: string;
  label: string;
  total?: number;
}

interface StatusFilterProps {
  items: FilterItem[];
  value: string;
  classStyle?: string;
  // For the read-only detail pages: the selection still shows, it just cannot
  // be changed.
  disabled?: boolean;
  onChange: (value: string) => void;
}

const StatusFilter = ({ items, value, onChange, classStyle, disabled }: StatusFilterProps) => {
  return (
    <>
      {items.map((item) => {
        const active = value === item.id;

        return (
          <button
            type="button"
            key={item.id}
            disabled={disabled}
            onClick={() => onChange(item.id)}
            className={cn(
              'p-3 rounded-full border transition-all duration-200 ',
              disabled ? 'cursor-default opacity-60' : 'cursor-pointer',
              classStyle,
              active
                ? 'bg-text-blue-100 text-white border-text-blue-100 title2bold'
                : `bg-db-wrap  border border-db-border title2 ${disabled ? '' : 'hover:opacity-70'}`
            )}
          >
            {item.label} {item.total}
          </button>
        );
      })}
    </>
  );
};

export default StatusFilter;
